import { mapProps, compose } from 'recompose';
import { pipe, head, split, last, concat } from 'ramda';
import DiscountTag from './DiscountTag';

const getReferenceAmount = pipe(head, split('_'), last);

const configureProps = mapProps(({ product }) => {
  const {
    totalReferencePrice: referencePrice, totalPrice: price, references, amount, tag, promo, discount,
  } = product;
  if (promo) {
    const referenceAmount = getReferenceAmount(references);
    const referenceAdUnit = referencePrice / referenceAmount;
    const adUnitPrice = price / amount;
    const discountPercentage = (((referenceAdUnit - adUnitPrice) / referenceAdUnit) * 100).toFixed(0);
    return { text: concat(discountPercentage, '% OFF') };
  }

  if (price.previous) {
    return { text: `${discount}% OFF` };
  }

  return { text: tag.toUpperCase() };
});

export default compose(configureProps)(DiscountTag);
